import { useState } from "react";
import data from "@emoji-mart/data";
import Picker from "@emoji-mart/react";
import fa from "./emoji-data/native.json";
import SendMessageBtn from "./Btn";
import SendMessageEmoji from "./Empoji";
import SendMessageFile from "./File";
import SendMessageInput from "./Input";
import ToastCustom from "../../../UI/ToastCustom";
import { ReactSVG } from "react-svg";
import { useDispatch, useSelector } from "react-redux";
import { useCookies } from "react-cookie";
import { useParams } from "react-router-dom";
import {
  ADD_REALTIME_MESSAGE,
  ADD_TEXT_MESSAGE_ITEM_TO_CHAT,
  SVAE_MESSAGE_INPUT_USER_IN_CHAT_PAGE,
} from "../../../../redux/action/messages/chat/chatType";
import { sendMessageToChat } from "../../../../redux/action/messages/chat/chatAction";
import { ADD_TO_LIST_MESSAGES } from "../../../../redux/action/messages/list/listType";

const SendMessageFooter = (props) => {
  const sendingError = useSelector(
    (state) => state.messages.chat.sendingMessageWasFail,
  );

  const [showEmoji, setShowEmoji] = useState("");
  const [lastEmoji, setLastEmoji] = useState("");

  const [textInput, setTextInput] = useState("");
  const [selectTextInputStart, setSelectTextInputStart] = useState(0);
  const [selectTextInputEnd, setSelectTextInputEnd] = useState(0);

  // send message
  const dispatch = useDispatch();
  const error = useSelector((state) => state.messages.chat.error);
  const messages = useSelector((state) => state.messages.chat.messages);
  const chat_delay_time = useSelector(
    (state) => state.messages.chat.chat_delay_time,
  );
  const [sendChatDelay, setSendChatDelay] = useState(0);
  const receiver = useSelector((state) => state.messages.chat.receiver);
  const loading = useSelector((state) => state.messages.chat.loading);
  const [cookies] = useCookies(["authToken"]);
  const params = useParams();

  const handleShowEmoji = () => {
    setShowEmoji(!showEmoji);
  };

  const addEmoji = (event) => {
    const emoji = event.native;

    setLastEmoji(emoji);

    const textStart = textInput.slice(0, selectTextInputStart);
    const textEnd = textInput.slice(selectTextInputEnd);

    setTextInput(textStart + emoji + textEnd);
  };

  const hideEmoji = () => {
    setShowEmoji(false);

    document.body.classList.remove("modal-opened");
  };

  const addMyMessage = (event) => {
    event.preventDefault();

    // send message
    if (textInput.length >= 1) {
      hideEmoji();
    }
  };

  function cleanHtmlTags(input) {
    if (!input) return "";
    const tempDiv = document.createElement("div");
    tempDiv.innerHTML = input;
    return tempDiv.textContent || tempDiv.innerText || "";
  }
  const sendMessage = async () => {
    props.setLoadingResponse(true);
    const text = cleanHtmlTags(textInput);
    if (text.length >= 1 && sendChatDelay === 0) {
      const id = Math.random() * 209384 + "text-item";

      // add message for show fake message. (message is loading)
      dispatch({
        type: ADD_TEXT_MESSAGE_ITEM_TO_CHAT,
        payload: {
          id: id,
          body: text,
          type: "text",
          file: null,
          seen: false,
          status: "loading",
          receiver_id: params.id,
          date: new Date()?.toLocaleDateString("fa", {
            year: "numeric",
            month: "2-digit",
            day: "2-digit",
            timeZone: "+0330",
          }),
        },
      });

      setTimeout(() => {
        window.scrollTo({
          top: window.document.body.scrollHeight + 10000,
        });
      }, 9);

      setTextInput("");

      dispatch({
        type: SVAE_MESSAGE_INPUT_USER_IN_CHAT_PAGE,
        payload: {
          inputText: "",
          userId: params.id,
        },
      });

      // add message to server
      const data = await dispatch(
        await sendMessageToChat(params.id, text, cookies.authToken, id),
      );

      if (data) {
        if (params.id == 2) {
          dispatch({
            type: ADD_REALTIME_MESSAGE,
            payload: {
              body: data.data.response,
              created_at: new Date(),
              file: null,
              id: data.data.id,
              receiver_id: params.id,
              seen: true,
              sender_id: 2,
              type: "text",
            },
          });
        }

        if (messages.length === 0) {
          const newmessage = {
            id: params.id,
            name: receiver.name,
            mobile: params.phone,
            image: receiver.image,
            unseen_count: 0,
            last_message: {
              id: Math.random() * 209384 + "text-item",
              type: "text",
              body: text,
              created_at: new Date(),
            },
          };
          dispatch({
            type: ADD_TO_LIST_MESSAGES,
            payload: newmessage,
          });
        }
      }
      setSendChatDelay(chat_delay_time);
    }
    props.setLoadingResponse(false);
  };

  return (
    <footer className="lg:w-3/4 w-full fixed bottom-0 left-0 lg:p-4 pt-4 pb-4 select-none bg-custom-gray z-[1]">
      <div className="w-full lg:px-0 px-3 relative">
        <form
          onSubmit={addMyMessage}
          action=""
          className="flex items-end gap-4 relative"
        >
          <SendMessageBtn
            sendChatDelay={sendChatDelay}
            setSendChatDelay={setSendChatDelay}
            error={error}
            loading={loading}
            invite={props.invite}
            sendMessage={sendMessage}
          />

          <SendMessageInput
            value={textInput}
            onUpdateTextInput={setTextInput}
            onSetSelectTextInputStart={setSelectTextInputStart}
            onSetSelectTextInputEnd={setSelectTextInputEnd}
            lastEmoji={lastEmoji}
            onHideEmoji={hideEmoji}
            showEmoji={showEmoji}
            sendMessage={sendMessage}
          />

          <SendMessageEmoji
            showEmoji={showEmoji}
            onHandleShowEmoji={handleShowEmoji}
          />

          <SendMessageFile />
        </form>

        {showEmoji && (
          <Picker
            data={data}
            i18n={fa}
            set="native"
            theme="light"
            previewPosition="none"
            searchPosition="none"
            onEmojiSelect={addEmoji}
          />
        )}
      </div>

      {sendingError && (
        <ToastCustom className="lg:-translate-x-2/3">
          <div className="flex items-center gap-2">
            <ReactSVG
              className="text-rose-500/90 4xm:w-8 w-6"
              src={`${process.env.PUBLIC_URL}/assets/images/icons/info-box.svg`}
            />

            {sendingError}
          </div>
        </ToastCustom>
      )}
    </footer>
  );
};

export default SendMessageFooter;
